import { useState } from "react";
import "../styles/Dropdown.css";

function Dropdown({label, texte, className}) {
  const [open, setOpen] = useState(false);

  return (
    <div className={`dropdown-item ${className || ""}`}>
      <button className="dropdown-header" onClick={() => setOpen(!open)}>
        <span className="dropdown-question">{label}</span>
        <span className={`dropdown-arrow ${open ? "open" : ""}`}>▼</span>
      </button>

      <div className={`dropdown-content ${open ? "show" : ""}`}
        dangerouslySetInnerHTML={{ __html: texte }}
      /> 
    </div>
 
  );
}

export default Dropdown;



      
   